import React from 'react';

import NotificationPreferencesEditor from '../settings/NotificationPreferencesEditor';


const UserNotificationPreferences = ({ userId, userName, onPreferencesUpdated }) => {
    return (
        <NotificationPreferencesEditor
            mode="admin"
            userId={userId}
            userName={userName}
            onUpdated={onPreferencesUpdated}
            allowTesting={false}
        />
    );
};


export default UserNotificationPreferences;